import { useId, useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import './NextChapterCTA.css';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function NextChapterCTA({ ready = true, staysHref = '/stay' }) {
  const scope = useRef(null);
  const titleId = useId();

  useGSAP(() => {
    if (!ready) return;
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const select = gsap.utils.selector(scope);
      gsap.timeline({
        defaults: { duration: 0.8, ease: 'power3.out', clearProps: 'transform,opacity,visibility' },
        scrollTrigger: { trigger: scope.current, start: 'top 85%', once: true },
      })
        .from(select('.next-chapter-cta__card'), { autoAlpha: 0, y: 24, scale: 0.985 }, 0)
        .from(select('.next-chapter-cta__eyebrow'), { autoAlpha: 0, y: 8 }, 0.2)
        .from(select('.next-chapter-cta__heading'), { autoAlpha: 0, y: 20 }, 0.3)
        .from(select('.next-chapter-cta__description'), { autoAlpha: 0, y: 14 }, 0.4)
        .from(select('.next-chapter-cta__action'), { autoAlpha: 0, x: 22 }, 0.5);
    });
    return () => media.revert();
  }, { scope, dependencies: [ready], revertOnUpdate: true });

  return (
    <section ref={scope} className="next-chapter-cta" aria-labelledby={titleId}>
      <div className="next-chapter-cta__card">
        <div className="next-chapter-cta__copy">
          <p className="next-chapter-cta__eyebrow">YOUR NEXT CHAPTER</p>
          <h2 className="next-chapter-cta__heading" id={titleId}>Somewhere good is waiting.</h2>
          <p className="next-chapter-cta__description">Choose your place. Bring your plans. Make yourself at home.</p>
        </div>
        <div className="next-chapter-cta__action">
          <a className="next-chapter-cta__button" href={staysHref}>
            <span>Find your stay</span>
            <span className="next-chapter-cta__arrow" aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}
